import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900, cyan500 } from 'material-ui/styles/colors';// eslint-disable-line no-unused-vars
import MenuItem from 'material-ui/MenuItem'; // eslint-disable-line no-unused-vars
import Checkbox from 'material-ui/Checkbox';
import SelectField from 'material-ui/SelectField';
import _ from 'lodash';

const propTypes = {
  promotions: PropTypes.any,
  promotion: PropTypes.object,
  onSave: PropTypes.func,
  salesChannels: PropTypes.array,
  discounts: PropTypes.array,
};

class ViewPromotion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    let promotion = nextProps.promotion;
    promotion.startDate = (promotion.startDate !== null) ? promotion.startDate.split('T')[0] : {};
    promotion.endDate = (promotion.endDate !== null) ? promotion.endDate.split('T')[0] : {};
    if (promotion.id) {
      promotion = nextProps.promotion;
    } else {
      promotion = nextProps.promotions.results[0];
    }
    promotion.id = (promotion.id === null) ? 0 : promotion.id;
    this.setState({ promotion });
  }
  navigateToEdit() {
    browserHistory.push(`/promotions/${this.state.promotion.id}`);
  }
  handleCancel() {
    browserHistory.push('/promotions?page=1');
  }
  render() {
    const discount = _.filter(this.props.discounts, d => d.id === this.props.promotion.discountId);
    const discountName = (discount && discount[0]) ? discount[0].name : '';
    const promoSalesChannels = this.props.promotion.salesChannels;
    const allSalesChannels = [{ name: 'All Sales Channels', id: 0 }];
    const salesChannels = allSalesChannels.concat(this.props.salesChannels);
    const isTrue = true;

    const scSelect = _.map(salesChannels, sc => <MenuItem
      value={sc.id}
      key={sc.id}
      label={sc.name}
      primaryText={sc.name}
      checked={promoSalesChannels && promoSalesChannels.includes(sc.id)}
    />);
    const styles = {
      scrollDivStyle: {
        width: '250px',
        display: 'inline-block',
        color: cyan900,
        fontSize: '12px',
        marginTop: '10px',
      },
      listStyle: {
        display: 'inline-block',
        verticalAlign: 'text-top',
        height: '70px',
        overflow: 'auto',
      },
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
      datePickerStyle: {
        marginRight: '2%',
        width: '250px',
        float: 'left',
      },
    };
    return (
      <div>
        <div className="float-right">
          <RaisedButton
            style={{ marginRight: '20px' }}
            label="Cancel"
            primary
            onClick={this.handleCancel}
          />
          <RaisedButton
            label="Edit"
            primary
            onClick={this.navigateToEdit}
          />
        </div>
        <br />
        <TextField
          floatingLabelText="ID"
          floatingLabelStyle={styles.floatingLabelStyle}
          inputStyle={styles.inputStyle}
          value={this.props.promotion.id || ''}
        />
        <br />
        <TextField
          floatingLabelText="Name"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={this.props.promotion.name || ''}
          name="name"
          style={styles.inputStyle}
        />
        <TextField
          floatingLabelText="Description"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={this.props.promotion.description || ''}
          name="description"
          style={styles.inputStyle}
        />
        <TextField
          floatingLabelText="Promotion Code"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={this.props.promotion.promoCode || ''}
          name="promoCode"
          style={styles.inputStyle}
        />
        <TextField
          floatingLabelText="Maximum Uses"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={this.props.promotion.maxUses || ''}
          name="maxUses"
          style={styles.inputStyle}
        />
        <TextField
          floatingLabelText="Start Date"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={this.props.promotion.startDate || ''}
          name="startDate"
          style={styles.inputStyle}
        />
        <TextField
          floatingLabelText="End Date"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={this.props.promotion.endDate || ''}
          name="endDate"
          style={styles.inputStyle}
        />
        <TextField
          floatingLabelText="Discount"
          floatingLabelStyle={styles.floatingLabelStyle}
          value={discountName}
          name="discountId"
          style={styles.inputStyle}
        />
        <SelectField
          value={salesChannels || []}
          multiple={isTrue}
          floatingLabelText="Sales Channels"
          style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
          name="salesChannels"
          floatingLabelStyle={styles.floatingLabelStyle}
        >
          {scSelect}
        </SelectField>
        <br />
        <br />
        <br />
        <ul>
          <li>
            <Checkbox
              label="Disabled"
              checked={this.props.promotion.disabled}
              name="disabled"
            />
          </li>
          <li>
            <Checkbox
              label="One use limit"
              checked={this.props.promotion.useOnce}
              name="useOnce"
            />
          </li>
          <li>
            <Checkbox
              label="Non buyer"
              checked={this.props.promotion.nonBuyer}
              name="nonBuyer"
            />
          </li>
          <li>
            <Checkbox
              label="Free Shipping"
              defaultChecked={freeShipping}
              name="freeShipping"
              onCheck={!disableFields ? handleChange : ''}
            />
          </li>
        </ul>
      </div>
    );
  }
}

ViewPromotion.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ViewPromotion.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    promotions: state.promotions,
    promotion: state.promotions.promotion,
    salesChannels: state.salesChannels.results,
    discounts: state.discounts.results,
  };
}

export default connect(mapStateToProps)(ViewPromotion);



// WEBPACK FOOTER //
// ./src/components/promotions/ViewPromotion.js